import { kMeans } from './kmeans.js';
import { utils } from '../utils.js';
import { historie } from '../history.js';
import { userimage } from '../tools/userimage';
import { beads } from '../beads.js';
import { settings } from '../settings.js';
import { palette } from '../palette.js';

export const bake = (paletteSize, method, limitBake) => {

    if (userimage.ignoreBake) return;

    // check we have a user-image on the canvas
    if (userimage.image === undefined) return;

    userimage.image.setAlpha(0.5);

    let shift = userimage.image.getTopLeft();
    let theta = -userimage.image.rotation;

    let returnLocalXY = (x, y) => {
        let newX = x - shift.x;
        let newY = y - shift.y;
        return {
            x: Math.round(newX * Math.cos(theta) - newY * Math.sin(theta)),
            y: Math.round(newY * Math.cos(theta) + newX * Math.sin(theta))
        };
    };

    // convert canvas x y to userimage local x y

    let corners = [userimage.image.getTopLeft(), userimage.image.getTopRight(), userimage.image.getBottomLeft(), userimage.image.getBottomRight()];

    let newCorners = [];

    corners.forEach(point => newCorners.push(returnLocalXY(point.x, point.y)));

    let pixelData = [];
    let beadsToPaint = [];

    beads.arr.forEach(bead => {
        if (bead.ignore) return;
        if (bead.hidden) return;
        let point = returnLocalXY(bead.x, bead.y);
        let myTexture = userimage.image.texture.key;

        if (
            point.x < newCorners[1].x &&
            (point.y < newCorners[2].y) &&
            (point.x > 0) &&
            (point.y > 0)
        ) {
            let newPoint = {
                x: Math.round(point.x / userimage.image.scale),
                y: Math.round(point.y / userimage.image.scale)
            }

            let pixel = game.textures.getPixel(newPoint.x, newPoint.y, myTexture);

            if (pixel) {
                if (method == 'RGB') {
                    pixelData.push([pixel.r, pixel.g, pixel.b]);
                } else if (method == 'HSV') {
                    let myHSV = Phaser.Display.Color.RGBToHSV(pixel.r, pixel.g, pixel.b);
                    pixelData.push([myHSV.h, myHSV.s, myHSV.v]);
                }

                beadsToPaint.push(bead);
            }
        }
    });

    if (pixelData.length == 0) {
        b3.store.mySet('showingModal', null);
        return;
    }

    let cData = [];

    if (limitBake) { // use existing palettes instead of creating centroids
        if (b3.store.state.swatches.length == 0) { // don't bake if we have no colors
            b3.store.mySet('showingModal', null);
            return;
        }
        b3.store.state.swatches.forEach(swatch => {
            let myColor = Phaser.Display.Color.IntegerToColor(swatch.fillColor);
            cData.push({
                centroid: [myColor.r, myColor.g, myColor.b],
                id: swatch.id
            });
        });
    } else {
        //number of clusters, defaults to undefined
        kMeans.k(paletteSize);

        //number of iterations (higher number gives more time to converge), defaults to 1000
        kMeans.iterations(50);

        //data from which to identify clusters, defaults to []
        kMeans.data(pixelData);

        cData = kMeans.clusters();
    }

    // assign every pixel to the closest centroid

    let leastDistance = null;
    let dist = null;
    let closestCentroid = 0;

    pixelData.forEach(pixel => {
        leastDistance = null;
        closestCentroid = 0;

        cData.forEach((element, i) => {
            dist = Math.sqrt(
                ((pixel[0]-element.centroid[0]) * (pixel[0]-element.centroid[0])) +
                ((pixel[1]-element.centroid[1]) * (pixel[1]-element.centroid[1])) +
                ((pixel[2]-element.centroid[2]) * (pixel[2]-element.centroid[2]))
            );
            if (!leastDistance) {
                leastDistance = dist;
                closestCentroid = i;
            }
            if (dist < leastDistance) {
                leastDistance = dist;
                closestCentroid = i;
            }
        });
        pixel.closestCentroid = closestCentroid;
    });

    // (use library part deleted -- find in earlier versions)

    if (!limitBake) {
        // assign each centroid a color, finishname, description

        cData.forEach(element => {
            if (method == 'RGB') {
                let r = Math.floor(element.centroid[0]);
                let g = Math.floor(element.centroid[1]);
                let b = Math.floor(element.centroid[2]);
                element.color = Phaser.Display.Color.GetColor(r, g, b);
            } else if (method == 'HSV') {
                let myColorObj = Phaser.Display.Color.HSVToRGB(...element.centroid);
                element.color = myColorObj.color;
            }

            element.finishName = (settings.library.shape === 'cylinder') ? 'cylinder_matte' : 'matte';
            element.description = utils.returnApproxColor(element.color);
        });


        // add swatches
        cData.forEach(element => {
            let myNewSwatch = palette.addSwatch({
                fillColor: element.color,
                description: element.description,
                finishName: element.finishName,
                inner: 'opaque',
                secondColor: null
            });
            element.id = myNewSwatch.id;
        });
    }

    // add color to the beads

    pixelData.forEach((element, i) => {
        beadsToPaint[i].style = cData[element.closestCentroid].id;
        beadsToPaint[i].active = true;
    });

    beads.refreshCanvas();

    b3.store.mySet('showingModal', null);

    document.body.style.cursor = 'default';
    historie.addAction();
};

